import { useState } from 'react';
import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import { useSnackbar } from 'notistack';
import { formataNumeroCelular } from 'src/utils/functions';
import MenuChannelChat from 'src/components/@dashboard/funil/MenuChannelChat';
import { Button } from 'src/@/components/ui/button';
import { Badge } from 'src/@/components/ui/badge';

// ----------------------------------------------------------------------

NegociosHeader.propTypes = {
    lead: PropTypes.object,
    user: PropTypes.object,
    cliente: PropTypes.object,
    onOpenChatWhatsapp: PropTypes.func,
    onDesvincularChat: PropTypes.func
};

export default function NegociosHeader({ lead, user, cliente, onOpenChatWhatsapp, onDesvincularChat, onVincularChat }) {
    const { enqueueSnackbar } = useSnackbar();
    const [anchorMenu, setAnchorMenu] = useState(null);

    const showMessage = (message, variant = 'success') => {
        enqueueSnackbar(message, { 
            variant, 
            autoHideDuration: 3000, 
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' } 
        });
    };

    const handleChatAction = async (action, chat = null) => {
        try {
            if (lead?.closed) {
                showMessage('Não é possível alterar, reabra o lead antes de continuar', 'error');
                return;
            }

            if (action === 'vincular' && onOpenChatWhatsapp) {
                await onVincularChat(chat);
                showMessage('Chat vinculado com sucesso!');
            } else if (action === 'desvincular' && onDesvincularChat) {
                await onDesvincularChat();
                showMessage('Chat desvinculado com sucesso');
            }
            
            setAnchorMenu(null);
        } catch (error) {
            console.error(`Erro ao ${action} chat:`, error);
            showMessage(`Erro ao ${action} chat`, 'error');
        }
    };

    return (
        <div className="flex items-center gap-3">
            
            {/* Chat vinculado ou botão de adicionar */}
            {lead?.whatsapp ? (
                <Badge
                    variant="outline"
                    className="bg-white dark:bg-[#222529] border border-green-300 dark:border-green-500/30 rounded-lg cursor-pointer hover:bg-green-50 dark:hover:bg-green-500/10 hover:border-green-400 dark:hover:border-green-500/40 transition-all duration-200 shadow-sm px-3 py-1.5"
                    onClick={() => onOpenChatWhatsapp(lead.whatsapp)}
                >
                    <div className="flex items-center gap-2">
                        <Iconify icon="ic:baseline-whatsapp" className="w-4 h-4 text-green-600" />
                        <span className="text-sm font-medium text-gray-700 dark:text-[#D1D2D3]">
                            {formataNumeroCelular(lead.whatsapp.numero)}
                        </span>
                        <button
                            className="ml-1 p-0.5 text-gray-400 dark:text-[#ABABAD] hover:text-red-500 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 rounded transition-all duration-200"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleChatAction('desvincular');
                            }}
                            title="Desvincular chat"
                        >
                            <Iconify icon="mdi:clear-bold" className="w-3.5 h-3.5" />
                        </button>
                    </div>
                </Badge>
            ) : (
                <Button
                    variant="outline"
                    size="sm"
                    className="h-8 px-3 border-dashed border-gray-300 dark:border-[#383838] text-gray-600 dark:text-[#ABABAD] hover:border-gray-400 dark:hover:border-[#565856] hover:text-gray-700 dark:hover:text-[#D1D2D3] hover:bg-gray-50 dark:hover:bg-[#383838]/50 text-xs"
                    onClick={(e) => setAnchorMenu(e.currentTarget)}
                >
                    <Iconify width={14} height={14} icon="gala:add" className="mr-1.5" />
                    Adicionar Chat
                </Button>
            )}

            {/* Menu de seleção de chat */}
            <MenuChannelChat
                anchorEl={anchorMenu}
                open={Boolean(anchorMenu)}
                onClose={() => setAnchorMenu(null)}
                cliente={cliente}
                user={user}
                onSelectChat={(chat) => handleChatAction('vincular', chat)}
            />
        </div>
    );
}
